const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

export type UtmParams = Partial<Record<(typeof UTM_KEYS)[number], string>>;

const STORAGE_KEY = "tezam:utm";

export function captureUtmFromLocation(): UtmParams {
    if (typeof window === "undefined") return {};
    const params = new URLSearchParams(window.location.search);
    const next: UtmParams = {};
    for (const key of UTM_KEYS) {
        const value = params.get(key)?.trim();
        if (value) next[key] = value;
    }
    const stored = readStoredUtm();
    const merged = { ...stored, ...next };
    try {
        if (Object.keys(merged).length > 0) {
            window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
        }
    } catch {
        /* ignore */
    }
    return merged;
}

export function readStoredUtm(): UtmParams {
    if (typeof window === "undefined") return {};
    try {
        const raw = window.sessionStorage.getItem(STORAGE_KEY);
        if (!raw) return {};
        return JSON.parse(raw) as UtmParams;
    } catch {
        return {};
    }
}
